export default __webpack_public_path__ + "assets/models/cd546a58a2a2f2a618b7d4da8866a66a.glb";